/* This module provides context for application data */

import React, { useContext, useState, createContext, useEffect } from 'react';
import analytics from 'lib/analytics';
import application from 'lib/application';
import { makeApplication } from 'lib/factories';

const ApplicationContext = createContext({});

const ApplicationProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [values, setValues] = useState();
  const [metadata, setMetadata] = useState();

  useEffect(() => {
    const getMetadata = async () => {
      const result = await application.retrieveMetadata();

      if (result) {
        setMetadata(result);
      }
    };

    if (!metadata) {
      getMetadata();
    }
  }, [metadata]);

  useEffect(() => {
    const getApplication = async () => {
      const result = await application.retrieve();

      if (result) {
        setValues(makeApplication(result));

        // identify user
        analytics.identify(result.analytics_id);
      }
      setIsLoading(false);
    };

    if (!values) {
      getApplication();
    }
  }, [values]);

  const create = async (formData) => {
    return await application.create(formData);
  };

  const update = async (formData) => {
    return await application.update(formData);
  };

  const upload = async (document_key, file, owner_key) => {
    try {
      return await application.upload(document_key, file, owner_key);
    } catch (error) {
      return error;
    }
  };

  const submit = async () => {
    return await application.submit();
  };

  const contextValue = {
    values,
    metadata,
    create,
    update,
    upload,
    submit,
    isLoading,
  };

  return (
    <ApplicationContext.Provider value={contextValue}>
      {children}
    </ApplicationContext.Provider>
  );
};

export const useApplication = () => useContext(ApplicationContext);

export default ApplicationProvider;
